/**
 * Fixed ORME section structure for the two structured compartments. Keys match
 * the server `ProductLine.RECIPE_READING_SECTIONS` / `PLATE_READING_SECTIONS`.
 */

export const RECIPE_SECTIONS = [
  { key: 'declaredRecipe', label: 'Ricetta dichiarata' },
  { key: 'ingredientAnalysis', label: 'Analisi dei singoli ingredienti' },
  { key: 'reasonedBreakdown', label: 'Scomposizione tecnica ragionata' },
  { key: 'analyticalComponents', label: 'Analisi dei componenti analitici' },
  { key: 'notOnLabel', label: 'Cosa non troviamo in etichetta' },
  { key: 'ormePlate', label: 'Il Piatto ORME' },
  { key: 'structuredEvaluation', label: 'Valutazione degli ingredienti strutturati' },
  { key: 'finalQuestion', label: 'Domanda finale del Metodo ORME' }
];

export const PLATE_SECTIONS = [
  { key: 'ingredientsReal', label: 'Traduzione in ingredienti reali' },
  { key: 'tableVisualization', label: 'Visualizzazione delle materie prime sul tavolo' },
  { key: 'roleAnalysis', label: 'Ruolo nutrizionale di ogni componente' },
  { key: 'imaginedVsReal', label: 'Immaginato dal cliente vs contenuto reale' },
  { key: 'undeclaredEstimate', label: 'Stima delle componenti non dichiarate' },
  { key: 'realPlate', label: 'Ricostruzione del piatto reale' },
  { key: 'transparency', label: 'Valutazione della trasparenza' },
  { key: 'finalQuestion', label: 'Domanda finale del Metodo ORME' }
];

/**
 * Seed a `{ [key]: text }` editing map from a stored reading, keeping the fixed
 * section order and filling gaps with empty strings.
 */
export function readingToMap(defs, reading) {
  const byKey = {};
  (reading?.sections || []).forEach((s) => { byKey[s.key] = s.body?.text || ''; });
  const map = {};
  defs.forEach((d) => { map[d.key] = byKey[d.key] || ''; });
  return map;
}

/**
 * Build a stored reading payload from the editing map.
 */
export function mapToReading(defs, map) {
  return {
    sections: defs.map((d) => ({
      key: d.key,
      title: d.label,
      body: { format: 'markdown', text: map[d.key] || '' }
    }))
  };
}
